// Dependencies
import React, { Component } from "react";
import _ from "lodash";

// Store
import { ActionCreator } from "../../../../../actions/actions";
import { connect } from "react-redux";
import { HallsActionCreators } from "../../../actions/actionCreators";
import { hallsStoreSelectors } from "../../../store/store";
import { ConfigVersion } from "../../../../configurations/reducers/configurationsList.reducer";
import { HallBaseConfig } from "../../../reducers/hallsList.reducer";

// Dictionaries
import {
    SETTINGS_FIELD_NAMES,
    EXTRA_BALL_PURCHASE_DICT
} from "../../../../configurations/components/ConfigurationsPage/NewConfigurationPage/SettingsConfigurationSection/FormBuild/SettingsConfiguratinSection.constants";
import { EXPIRATION_TYPE_DICT } from "../../../../configurations/components/ConfigurationsPage/NewConfigurationPage/AccountingConfigurationSection/FormBuild/AccountingConfiguration.constants";
import {
    ACCOUNTING_FIELD_NAMES,
    ACCOUNTING_SYSTEM_DICT,
    VOUCHER_DIGITS_DICT,
    PROVIDER_DICT
} from "../../../../configurations/components/ConfigurationsPage/NewConfigurationPage/AccountingConfigurationSection/FormBuild/AccountingConfiguration.constants";
import { GLOBAL_JACKPOT_FIELD_NAMES } from "../../../../configurations/components/ConfigurationsPage/NewConfigurationPage/GlobalJackpotConfigurationSection/FormBuild/GlobalJackpotConfigurationSection.constants";
import { SPECIAL_PRIZES_FIELD_NAMES } from "../../../../configurations/components/ConfigurationsPage/NewConfigurationPage/SpecialPrizesConfigurationSection/FormBuild/SpecialPrizesConfigurationSection.constants";
import { subsidiaryDenominations } from "../../../../../utils/addressUtils";

// Components
import { Components } from "@webtech/webtech-ui-react/build/webtech-ui";
import GroupsComponent from "./Groups/GroupsCompare.component";
import ProgressiveCompareComponent from "./Progressives/ProgressivesCompare.component";
import MailingListsCompare from "./MailingLists/MailingListsCompare.component";

// Styles
import "./ConfigurationsCompare.component.scss";
import { HallServer } from "../../../reducers/inspectingHall.reducer";
export interface ConfigurationsCompareProps {
    selectedForComparison: number[];
    onCompareClose: any;
    inspectingServerConfigurationsList: ConfigVersion[];
    compareConfigurationsLoading: boolean;
    compareConfigurations: any[];
    getCompareConfigurations: ActionCreator;
    inspectingHall: HallBaseConfig;
    inspectingServer: HallServer;
    inspectingHallLoading: boolean;
    inspectingServerLoading: boolean;
}

interface ConfigurationsCompareState {}

const SECTIONS_KEYS = {
    settings: SETTINGS_FIELD_NAMES,
    accounting: ACCOUNTING_FIELD_NAMES,
    global_jackpot: GLOBAL_JACKPOT_FIELD_NAMES,
    special_prizes: SPECIAL_PRIZES_FIELD_NAMES
};

const STATIC_KEYS = {
    system: value => {
        let match = ACCOUNTING_SYSTEM_DICT.find(item => item.value == value);
        return match.label;
    },
    voucher_digits: value => {
        let match = VOUCHER_DIGITS_DICT.find(item => item.value == value);
        return match.label;
    },
    provider: (value, ext) => {
        let match = undefined;
        if (ext == 0) {
            match = PROVIDER_DICT.find(item => item.value == value);
            return match.label;
        } else if (ext == 1) {
            match = PROVIDER_DICT.find(item => item.value == value);
            return match.label;
        }

        return undefined;
    },
    expiration_type: value => {
        let match = EXPIRATION_TYPE_DICT.find(item => item.value == value);
        return match.label;
    },
    extra_ball_purchase: value => {
        let match = EXTRA_BALL_PURCHASE_DICT.find(item => item.value == value);
        return match.label;
    }
};

class ConfigurationsCompare extends Component<
    ConfigurationsCompareProps,
    ConfigurationsCompareState
> {
    constructor(props: ConfigurationsCompareProps) {
        super(props);
        this.state = {};

        this.props.getCompareConfigurations({
            confIds: this.props.selectedForComparison,
            hall: this.props.inspectingHall,
            server: this.props.inspectingServer
        });
    }

    checkIfSectionAvailableToCompare = section => {
        let hasSection = false;

        this.props.selectedForComparison.map(configId => {
            const config = this.props.compareConfigurations.find(
                c => c.id === configId
            );

            if (config.settings.hasOwnProperty(section)) {
                if (
                    typeof config.settings[section] === "object" &&
                    Object.keys(config.settings[section]).length > 0
                ) {
                    hasSection = true;
                } else if (
                    _.isArray(config.settings[section]) &&
                    config.settings[section].length > 0
                ) {
                    hasSection = true;
                }
            }
        });

        return hasSection;
    };

    checkIfKeyExistsInOneConfig = (objectKey, key) => {
        let exists = false;
        this.props.compareConfigurations.map(config => {
            const configObject = config.settings[objectKey][key];
            if (configObject !== null && configObject !== undefined) {
                exists = true;
            }
        });

        return exists;
    };

    checkIfKeyIsObject = (objectKey, key) => {
        let isObject = false;
        this.props.compareConfigurations.map(config => {
            const configObject = config.settings[objectKey][key];
            if (
                configObject !== null &&
                configObject !== undefined &&
                typeof configObject == "object" &&
                !Array.isArray(configObject)
            ) {
                isObject = true;
            }
        });

        return isObject;
    };

    renderCellContent = (object, key, node, needsToConvert) => {
        let toRender = object;

        if (typeof object === "boolean") {
            toRender = object == true ? "Yes" : "No";
        } else if (object instanceof Array) {
            if (key == "coin") {
                toRender = (
                    <div className="bullets-select">
                        <div>
                            {object.map((coin, index) => {
                                return (
                                    <div key={index} className="bullet">
                                        {subsidiaryDenominations[
                                            this.props.inspectingHall.subsidiary.country.code.toUpperCase()
                                        ]((coin / 100).toString())}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                );
            } else {
                toRender = (
                    <ul>
                        {object.map((item, itemIndex) => (
                            <li key={itemIndex}>
                                {needsToConvert ? item / 100 : item}
                            </li>
                        ))}
                    </ul>
                );
            }
        } else if (STATIC_KEYS.hasOwnProperty(key)) {
            if (key == "provider") {
                toRender = STATIC_KEYS[key](toRender, node.system);
            } else {
                toRender = STATIC_KEYS[key](toRender);
            }
        }

        return needsToConvert ? toRender / 100 : toRender;
    };

    renderCell = (
        configObject,
        index,
        key,
        node,
        needsToConvert,
        innerClass = ""
    ) => {
        if (
            (typeof configObject !== "object" ||
                configObject instanceof Array) &&
            configObject !== undefined
        ) {
            let toRender = this.renderCellContent(
                configObject,
                key,
                node,
                needsToConvert
            );

            return (
                <td key={index} className={`value ${innerClass}`}>
                    <div>{toRender}</div>
                </td>
            );
        }

        return <td key={index}></td>;
    };

    renderRow = (objectKey, key, subKey = undefined, innerClass = "") => {
        const GAME_TYPES = {
            0: "bingo",
            1: "spins",
            2: "lotto",
            3: "keno"
        };
        return (
            <tr>
                {this.props.compareConfigurations.map((config, index) => {
                    if (
                        !config.settings[objectKey].hasOwnProperty(key) ||
                        config.settings[objectKey][key] == null ||
                        config.settings[objectKey][key] == undefined
                    ) {
                        return (
                            <td
                                key={`${config.id}-${key}`}
                                className={`value ${innerClass}`}
                            >
                                <div>-</div>
                            </td>
                        );
                    }

                    const configObject =
                        subKey == undefined
                            ? config.settings[objectKey][key]
                            : config.settings[objectKey][key].hasOwnProperty(
                                  subKey
                              )
                            ? config.settings[objectKey][key][subKey]
                            : undefined;
                    if (configObject !== undefined) {
                        if (
                            objectKey == "global_jackpot" &&
                            key == "game_groups"
                        ) {
                            return (
                                <td
                                    key={`${config.id}-${key}`}
                                    className={`value ${innerClass}`}
                                >
                                    <div className="bullets-select">
                                        <div>
                                            {config.settings[objectKey][
                                                key
                                            ].map(instanceId => {
                                                let game =
                                                    config.settings.game_settings.find(
                                                        instance =>
                                                            instance.id ==
                                                            instanceId
                                                    );
                                                return (
                                                    <div
                                                        key={instanceId}
                                                        className={`bullet ${
                                                            GAME_TYPES[game.type]
                                                        }`}
                                                    >
                                                        {game.name}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </td>
                            );
                        } else {
                            let isKeyEmpty =
                                config.settings[objectKey][key] == undefined ||
                                config.settings[objectKey][key] == null;
                            if (isKeyEmpty) {
                                return (
                                    <td
                                        key={`${index}-${
                                            subKey == undefined ? key : subKey
                                        }`}
                                        className={`value ${innerClass}`}
                                    >
                                        <div>&nbsp;</div>
                                    </td>
                                );
                            } else {
                                let schema = !config.settings[objectKey][
                                    key
                                ].hasOwnProperty(subKey)
                                    ? config.schema.components[objectKey].schema
                                          .properties[key]
                                    : undefined;
                                return this.renderCell(
                                    configObject,
                                    index,
                                    subKey == undefined ? key : subKey,
                                    config.settings[objectKey][
                                        key
                                    ].hasOwnProperty(subKey)
                                        ? config.settings[objectKey][key]
                                        : config.settings[objectKey],
                                    schema !== undefined &&
                                        schema.hasOwnProperty("convert") &&
                                        schema.convert == true,
                                    innerClass
                                );
                            }
                        }
                    } else {
                        return (
                            <td
                                key={`${index}-${
                                    subKey == undefined ? key : subKey
                                }`}
                                className={`value ${innerClass}`}
                            >
                                <div>&nbsp;</div>
                            </td>
                        );
                    }
                })}
            </tr>
        );
    };

    renderObjectRows = (objectKey, key) => {
        let keys = [];
        this.props.compareConfigurations.map(config => {
            if (
                config.settings.hasOwnProperty(objectKey) &&
                config.settings[objectKey].hasOwnProperty(key) &&
                config.settings[objectKey][key] !== null
            ) {
                keys = keys.concat(
                    Object.keys(config.settings[objectKey][key])
                );
            }
        });

        keys = _.uniq(keys);

        return keys.map(subKey => {
            if (
                SECTIONS_KEYS.hasOwnProperty(objectKey) &&
                SECTIONS_KEYS[objectKey].hasOwnProperty(subKey)
            ) {
                return (
                    <React.Fragment key={subKey}>
                        <tr className="inner-header inner-object">
                            <td
                                colSpan={
                                    this.props.selectedForComparison.length
                                }
                            >
                                {SECTIONS_KEYS[objectKey][subKey]}
                            </td>
                        </tr>
                        {this.renderRow(objectKey, key, subKey, "inner-value")}
                    </React.Fragment>
                );
            }
            return null;
        });
    };

    renderTable = (title, objectKey) => {
        let keys = [];
        this.props.compareConfigurations.map(config => {
            if (config.settings.hasOwnProperty(objectKey)) {
                keys = keys.concat(Object.keys(config.settings[objectKey]));
            }
        });

        keys = _.uniq(keys);

        if (keys.includes("spins")) {
            keys.push(keys.splice(keys.indexOf("spins"), 1)[0]);
        }

        if (keys.includes("bingo")) {
            keys.push(keys.splice(keys.indexOf("bingo"), 1)[0]);
        }

        if (keys.includes("lotto")) {
            keys.push(keys.splice(keys.indexOf("lotto"), 1)[0]);
        }

        if (keys.includes("keno")) {
            keys.push(keys.splice(keys.indexOf("keno"), 1)[0]);
        }

        return (
            <table id="table-comparative">
                <thead>
                    <tr>
                        <td colSpan={this.props.compareConfigurations.length}>
                            {title}
                        </td>
                    </tr>
                </thead>
                <tbody>
                    {keys.map(key => {
                        if (
                            SECTIONS_KEYS.hasOwnProperty(objectKey) &&
                            SECTIONS_KEYS[objectKey].hasOwnProperty(key) &&
                            this.checkIfKeyExistsInOneConfig(objectKey, key)
                        ) {
                            return (
                                <React.Fragment key={key}>
                                    <tr
                                        className={`inner-header ${
                                            this.checkIfKeyIsObject(
                                                objectKey,
                                                key
                                            )
                                                ? "object"
                                                : ""
                                        }`}
                                    >
                                        <td
                                            colSpan={
                                                this.props.selectedForComparison
                                                    .length
                                            }
                                        >
                                            <div>
                                                {SECTIONS_KEYS[objectKey][key]}
                                            </div>
                                        </td>
                                    </tr>
                                    {!this.checkIfKeyIsObject(objectKey, key) &&
                                        this.renderRow(objectKey, key)}
                                    {this.checkIfKeyIsObject(objectKey, key) &&
                                        this.renderObjectRows(objectKey, key)}
                                </React.Fragment>
                            );
                        } else if(objectKey === 'settings_hall'){
                            const subtitles = {
                                hall_name : "Hall Name",
                                address1 : "Hall Address 1",
                                address2 : "Hall Address 2",
                                server_name : "Server Name"
                            }
                            return (
                                <React.Fragment key={key}>
                                    <tr  className={`inner-header ${
                                    this.checkIfKeyIsObject(
                                        objectKey,
                                        key
                                    )
                                        ? "object"
                                        : ""
                                    }`}>
                                        <td colSpan={ this.props.selectedForComparison.length } >
                                            <div> {subtitles[key]} </div>
                                        </td>
                                    </tr>
                                    {this.renderRowSettingsHall(key, objectKey)}
                                </React.Fragment>)
                        }
                        return null;
                    })}
                </tbody>
            </table>
        );
    };

    renderRowSettingsHall = (key, objectKey) => {
        return (
            <tr>
                {this.props.compareConfigurations.map((config, index) => {
                    return (
                        <td key={`${config.id}-${key}`} className={`value`}>
                            <div>{config.settings[objectKey][key]}</div>
                        </td>
                    )
                })}
            </tr>
        );
    }

    mapGamesToGroups = (groups, gameIds) => {
        let gameGroups = [];
        groups.map(group => {
            gameIds.map(id => {
                if (group.game_instances.includes(id)) {
                    if (!gameGroups.includes(group.id)) {
                        gameGroups.push(group.id);
                    }
                }
            });
        });
        return gameGroups;
    };

    render() {
        let configsProgressives = [];
        let configsSpecialPrizes = [];
        this.props.compareConfigurations.map(config => {
            const groups =
                config.settings.jackpot_groups.use_terminal_groups == true
                    ? config.settings.jackpot_groups.terminal_groups
                    : config.settings.jackpot_groups.game_groups;

            let special_prizes = [...config.settings.special_prizes].map(sp => {
                sp.terminal_groups = sp.terminal_groups.map(tg => {
                    tg = groups.find(g => g.id == tg);
                    return tg;
                });

                const sp_game_groups = this.mapGamesToGroups(
                    groups,
                    sp.game_groups
                );

                sp.game_groups = sp_game_groups.map(gg => {
                    let ngg = { ...groups.find(g => g.id == gg) };
                    ngg.game_instances = ngg.game_instances.map(instanceId => {
                        let game = config.settings.game_settings.find(
                            instance => instance.id == instanceId
                        );

                        return game;
                    });
                    return ngg;
                });

                return sp;
            });

            let progressives = [...config.settings.progressives].map(
                progressive => {
                    if (
                        progressive.type !== "levels" &&
                        progressive.type !== "multipots" &&
                        progressive.type !== "jumbolink" &&
                        progressive.type !== "luckytokenslink" &&
                        progressive.type !== "reelstrike" &&
                        progressive.type !== "easylink" &&
                        progressive.type !== "sap"
                    ) {
                        progressive.terminal_groups =
                            progressive.terminal_groups.map(tg => {
                                tg = groups.find(g => g.id == tg);
                                return tg;
                            });

                        const progressive_game_groups = this.mapGamesToGroups(
                            groups,
                            progressive.game_groups
                        );

                        progressive.game_groups = progressive_game_groups.map(
                            gg => {
                                let ngg = { ...groups.find(g => g.id == gg) };
                                ngg.game_instances = ngg.game_instances.map(
                                    instanceId => {
                                        let game =
                                            config.settings.game_settings.find(
                                                instance =>
                                                    instance.id == instanceId
                                            );

                                        return game;
                                    }
                                );
                                return ngg;
                            }
                        );
                    } else {
                        progressive.children = progressive.children.map(
                            child => {
                                child.terminal_groups =
                                    child.terminal_groups.map(tg => {
                                        tg = groups.find(g => g.id == tg);
                                        return tg;
                                    });

                                const child_game_groups = this.mapGamesToGroups(
                                    groups,
                                    child.game_groups
                                );

                                child.game_groups = child_game_groups.map(
                                    gg => {
                                        let ngg = {
                                            ...groups.find(g => g.id == gg)
                                        };
                                        ngg.game_instances =
                                            ngg.game_instances.map(
                                                instanceId => {
                                                    let game =
                                                        config.settings.game_settings.find(
                                                            instance =>
                                                                instance.id ==
                                                                instanceId
                                                        );

                                                    return game;
                                                }
                                            );
                                        return ngg;
                                    }
                                );

                                return child;
                            }
                        );
                    }

                    return progressive;
                }
            );

            configsProgressives.push({
                schema: config.schema.components.progressives,
                progressives: progressives
            });
            configsSpecialPrizes.push({
                schema: config.schema.components.special_prizes,
                progressives: special_prizes
            });
        });

        /*configsProgressives = _.orderBy(configsProgressives, ["type"], ["asc"]);
        configsSpecialPrizes = _.orderBy(
            configsSpecialPrizes,
            ["type"],
            ["asc"]
        );*/

        return (
            <React.Fragment>
                <div
                    className={`dialog-header ${
                        this.props.selectedForComparison.length == 3
                            ? "extra-wide"
                            : ""
                    }`}
                >
                    <div>
                        <div className="compare-info">
                            <h1>Compare Configurations</h1>
                            <button onClick={this.props.onCompareClose}>
                                Close
                            </button>
                        </div>
                        {!this.props.compareConfigurationsLoading &&
                            this.props.compareConfigurations.length > 0 && (
                                <table>
                                    <tbody>
                                        <tr>
                                            {this.props.compareConfigurations.map(
                                                config => {
                                                    return (
                                                        <td
                                                            key={`header-cell-${config.id}`}
                                                        >
                                                            <div className="compare-cell">
                                                                V
                                                                {config.version}
                                                            </div>
                                                        </td>
                                                    );
                                                }
                                            )}
                                        </tr>
                                    </tbody>
                                </table>
                            )}
                    </div>
                </div>
                <div
                    className={`dialog-body ${
                        this.props.selectedForComparison.length == 3
                            ? "extra-wide"
                            : ""
                    }`}
                >
                    {this.props.compareConfigurationsLoading ||
                        this.props.inspectingHallLoading ||
                        this.props.inspectingServerLoading ||
                        (this.props.compareConfigurations.length == 0 && (
                            <div className="compare-configuration-loading">
                                <Components.LoadingRipple
                                    height={100}
                                    width={100}
                                />
                            </div>
                        ))}
                    {!this.props.compareConfigurationsLoading &&
                        !this.props.inspectingHallLoading &&
                        !this.props.inspectingServerLoading &&
                        this.props.compareConfigurations.length > 0 &&
                        this.checkIfSectionAvailableToCompare("settings_hall") &&
                        this.renderTable("Hall/Server Settings", "settings_hall")}

                    {!this.props.compareConfigurationsLoading &&
                        !this.props.inspectingHallLoading &&
                        !this.props.inspectingServerLoading &&
                        this.props.compareConfigurations.length > 0 &&
                        this.checkIfSectionAvailableToCompare("settings") &&
                        this.renderTable("General Settings", "settings")}

                    {!this.props.compareConfigurationsLoading &&
                        !this.props.inspectingHallLoading &&
                        !this.props.inspectingServerLoading &&
                        this.props.compareConfigurations.length > 0 &&
                        this.checkIfSectionAvailableToCompare("accounting") &&
                        this.renderTable("Accounting Settings", "accounting")}

                    {!this.props.compareConfigurationsLoading &&
                        !this.props.inspectingHallLoading &&
                        !this.props.inspectingServerLoading &&
                        this.props.compareConfigurations.length > 0 && (
                            <GroupsComponent
                                compareConfigurations={
                                    this.props.compareConfigurations
                                }
                                selectedForComparison={
                                    this.props.selectedForComparison
                                }
                            />
                        )}

                    {!this.props.compareConfigurationsLoading &&
                        !this.props.inspectingHallLoading &&
                        !this.props.inspectingServerLoading &&
                        this.props.compareConfigurations.length > 0 &&
                        this.checkIfSectionAvailableToCompare(
                            "progressives"
                        ) && (
                            <ProgressiveCompareComponent
                                objectKey="progressives"
                                title="Progressives"
                                configsToCompare={configsProgressives}
                                selectedForComparison={
                                    this.props.selectedForComparison
                                }
                            />
                        )}

                    {!this.props.compareConfigurationsLoading &&
                        !this.props.inspectingHallLoading &&
                        !this.props.inspectingServerLoading &&
                        this.props.compareConfigurations.length > 0 &&
                        this.checkIfSectionAvailableToCompare(
                            "special_prizes"
                        ) && (
                            <ProgressiveCompareComponent
                                objectKey="special_prizes"
                                title="Special Prizes"
                                configsToCompare={configsSpecialPrizes}
                                selectedForComparison={
                                    this.props.selectedForComparison
                                }
                            />
                        )}

                    {!this.props.compareConfigurationsLoading &&
                        !this.props.inspectingHallLoading &&
                        !this.props.inspectingServerLoading &&
                        this.props.compareConfigurations.length > 0 &&
                        this.checkIfSectionAvailableToCompare(
                            "global_jackpot"
                        ) &&
                        this.renderTable("Global Jackpot", "global_jackpot")}

                    {!this.props.compareConfigurationsLoading &&
                        !this.props.inspectingHallLoading &&
                        !this.props.inspectingServerLoading &&
                        this.props.compareConfigurations.length > 0 &&
                        this.checkIfSectionAvailableToCompare("mailing_lists") &&
                        (
                            <MailingListsCompare
                            compareConfigurations={this.props.compareConfigurations
                            }/>
                        )}
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    compareConfigurations: hallsStoreSelectors.compareConfigurations(state),
    compareConfigurationsLoading:
        hallsStoreSelectors.compareConfigurationsLoading(state),
    inspectingServerConfigurationsList: hallsStoreSelectors.select(
        "inspectingServerConfigurationsList"
    )(state),
    inspectingHall: hallsStoreSelectors.inspectingHall(state),
    inspectingServer: hallsStoreSelectors.inspectingServer(state),
    inspectingHallLoading: hallsStoreSelectors.inspectingHallLoading(state),
    inspectingServerLoading: hallsStoreSelectors.inspectingServerLoading(state)
});

const mapDispatchToProps = {
    getCompareConfigurations: HallsActionCreators.getCompareConfigurations
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ConfigurationsCompare);
